module.exports = __webpack_public_path__ + "static/media/hat_o.9dd49675.ogg";